import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import Search, {SearchInputType} from "@components/custom/Search";


interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
}

const SearchVideosComponent: React.FC<SearchInputProps> = props => {
  const {search} = props;
  
  const inputs = [{
    name : "query",
    label : <FormattedMessage id="app.title" defaultMessage={`Title`}/>,
    type : SearchInputType.TEXT,
    size : 12
  }];

  return <Search inputs={inputs} search={search}/>

};

export default SearchVideosComponent;